/**
 * Created by zhangdong on 2018/1/5.
 */
import wx from 'wx'

import  ApiSetting from "./api.js"
import  httpServer from "./http.js"

// 微信分享配置
export const wxShareConfig = ({title, desc, link, imgUrl}, success, fail, toShareUrl) => {
    var obj = {'url': link}
    // console.log("wxShareConfig " + link)
    httpServer(ApiSetting.getWechatShareInfo(), obj)
        .then((res) => {
            if (res.status == true) {
                wx.config({
                    debug: false,
                    appId: res.result.appId,
                    timestamp: res.result.timestamp,
                    nonceStr: res.result.nonceStr,
                    signature: res.result.signature,
                    jsApiList: [
                        'showMenuItems',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone'
                    ]
                })

                var shareLink = toShareUrl?toShareUrl:link;
                wx.ready(() => {
                    // “分享给朋友”
                    wx.onMenuShareAppMessage({
                        title: title,
                        desc: desc,
                        link: shareLink,
                        imgUrl: imgUrl,
                        success: success,
                        fail: fail
                    })
                    // “分享到朋友圈”
                    wx.onMenuShareTimeline({
                        title: title,
                        link: shareLink,
                        imgUrl: imgUrl,
                        success: success,
                        fail: fail
                    })

                    // 分享到QQ
                    wx.onMenuShareQQ({
                        title: title,
                        desc: desc,
                        link: shareLink,
                        imgUrl: imgUrl,
                        success: success,
                        fail: fail
                    })
                    // 分享到腾讯微博
                    wx.onMenuShareWeibo({
                        title: title,
                        desc: desc,
                        link: shareLink,
                        imgUrl: imgUrl,
                        success: success,
                        fail: fail
                    })
                    // 分享到QQ空间
                    wx.onMenuShareQZone({
                        title: title,
                        desc: desc,
                        link: shareLink,
                        imgUrl: imgUrl,
                        success: success,
                        fail: fail
                    })

                    wx.showMenuItems({
                        menuList: [
                            "menuItem:copyUrl",
                            'menuItem:share:appMessage',
                            'menuItem:share:timeline',
                            "menuItem:share:qq",
                            "menuItem:share:weiboApp",
                            "menuItem:favorite",
                            'menuItem:share:QZone',
                            "menuItem:profile"
                        ],
                        success:function () {
                            console.log( 'yes' );
                        },
                        fail:function (res) {
                            console.log( 'no' );
                        }
                    });
                })
            }
        }, (error) => {

        });


}



// WEBPACK FOOTER //
// ./src/js/common/utils.js